export const isAcceptGdprSelector = ({ gdpr }) => gdpr.isAcceptGdpr;
